import {
  WSButton,
  WSContainer,
  WSFlexBox,
  WSGrid,
  WSScreen,
  WSText
} from "@wingspanhq/fe-component-library";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { useUserId } from "../../query/hooks/helpers";
import { useUpdateActivity } from "../../query/users/mutations";
import { useActivities } from "../../query/users/queries";
import { FREE_TRIAL_DAYS } from "../../Settings/components/MembershipPackages/subscriptionPackages";
import { useWSStore } from "../../store";
import { FeatureInfo } from "../components/FeatureInfo/FeatureInfo";
import { OnboardingHeader } from "../components/OnboardingHeader/OnboardingHeader";
import { SubscriptionWidget } from "../components/SubscriptionWidget/SubscriptionWidget";

interface OnboardingStep4BenefitsProps {}
export const OnboardingStep4Benefits: React.FC<OnboardingStep4BenefitsProps> = () => {
  const history = useHistory();
  const store = useWSStore();

  const userId = useUserId();
  const qActivity = useActivities(userId);

  const benefitsOnly = qActivity.data?.events.benefitsOnlySignup;

  const [updateActivity, updateActivityMeta] = useUpdateActivity(userId, {
    throwOnError: true
  });

  const onBack = () => {
    history.push("/member/onboarding/step/3/benefits");
  };

  const content = (
    <>
      <WSScreen.Mobile>
        <FeatureInfo
          title="Big company benefits for you and yours."
          featureItems={[
            "We'll help you find, enroll in, and get the most out of your health insurance plan",
            "Talk to a doctor for free with 24/7 access to telemedicine",
            "Save 15% to 50% on dental expenses, 30% on alternative medicine"
          ]}
          virtualAssistantMessage={
            benefitsOnly
              ? undefined
              : "Wingspan is entirely tax deductible! And – you guessed it – we'll deduct it for you."
          }
        />
      </WSScreen.Mobile>
      <WSScreen.TabletAndDesktop>
        <FeatureInfo
          title="Big company benefits for you and yours."
          description="Wingspan can help you get the coverage you need and the perks you want with custom insurance and benefits packages for you and your family."
          featureItems={[
            "We'll help you find, enroll in, and get the most out of your health insurance plan",
            "Talk to a doctor for free with 24/7 access to telemedicine",
            "Dedicated support from your Health Advocate to negotiate bills",
            "Save 15% to 50% on dental expenses, 30% on alternative medicine",
            "Discounts on pet care"
          ]}
          virtualAssistantMessage={
            benefitsOnly
              ? undefined
              : "Wingspan is entirely tax deductible! And – you guessed it – we'll deduct it for you."
          }
        />
      </WSScreen.TabletAndDesktop>
    </>
  );

  return (
    <>
      <BrowserPageTitle title="Onboarding: Step 4 | Benefits" />
      <OnboardingHeader onBack={onBack} />
      <WSContainer verticalPadding>
        {benefitsOnly ? (
          <WSGrid.Centered XS={6} M={6}>
            {content}
            <WSText mt="L">
              Wingspan's benefits only plan is <b>$20</b> per month. Since we've
              partnered with <b>SellX</b>, get 30% off for 12 months after your
              30 day free trial.
            </WSText>
            <WSFlexBox.Center>
              <WSButton
                icon="lock"
                name="tryWSFree"
                onClick={async () => {
                  await updateActivity({
                    flows: {
                      onboarding: {
                        version: 3,
                        currentStep: 4,
                        totalSteps: 4,
                        complete: true
                      }
                    }
                  });
                  history.push("/member/onboarding/customizing");
                }}
                loading={updateActivityMeta.isLoading}
                mb="S"
                mt="L"
              >
                Try Wingspan free
              </WSButton>
            </WSFlexBox.Center>
          </WSGrid.Centered>
        ) : (
          <WSGrid.Container>
            <WSGrid.Item XS={6} M={6}>
              {content}
            </WSGrid.Item>
            <WSGrid.Item XS={6} M={6}>
              <SubscriptionWidget />
            </WSGrid.Item>
          </WSGrid.Container>
        )}
      </WSContainer>
    </>
  );
};
